import React from 'react';
import {
    Box,
    Card,
    Chip,
    Divider,
    Stack,
    Typography,
    useTheme,
} from "@mui/material";
import { toPriceWithComma } from "../../../helper/utils";
import { CreditUsageCategoryEnum } from "../../../helper/enums/CreditUsageCategoryEnum";

const _CreditBudgetPreview = ({
    recipientLabel,
    rawCreditAmount,
    recipientCount,
    usageCategories,
    blockedSportIds,
    estimatedTotal,
}) => {
    const theme = useTheme();

    return (
        <Card
            elevation={0}
            sx={{
                borderRadius: 4,
                border: '1px solid',
                borderColor: 'divider',
                bgcolor: 'background.paper',
                p: 3,
                position: 'sticky',
                top: 24,
            }}
        >
            <Typography variant="h6" sx={{ fontWeight: 800, mb: 2 }}>
                پیش‌نمایش و خلاصه
            </Typography>

            <Stack spacing={2}>
                <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                    <Typography variant="body2" color="text.secondary">دریافت‌کنندگان:</Typography>
                    <Typography variant="body2" sx={{ fontWeight: 800, color: 'primary.main' }}>
                        {recipientLabel}
                    </Typography>
                </Box>

                <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                    <Typography variant="body2" color="text.secondary">اعتبار فردی:</Typography>
                    <Typography variant="body2" sx={{ fontWeight: 800 }}>
                        {toPriceWithComma(rawCreditAmount)} تومان
                    </Typography>
                </Box>

                {recipientCount !== null && (
                    <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                        <Typography variant="body2" color="text.secondary">تعداد افراد:</Typography>
                        <Typography variant="body2" sx={{ fontWeight: 700 }}>
                            {recipientCount} نفر
                        </Typography>
                    </Box>
                )}

                <Divider sx={{ my: 1 }} />

                {/* Categories Breakdown */}
                <Box>
                    <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mb: 0.5 }}>
                        بخش‌های مصرف مجاز:
                    </Typography>
                    <Stack direction="row" spacing={0.6} flexWrap="wrap" useFlexGap>
                        {usageCategories.map(code => (
                            <Chip
                                key={code}
                                label={CreditUsageCategoryEnum[code]?.label || code}
                                size="small"
                                color="primary"
                                variant="outlined"
                                sx={{ fontWeight: 700, fontSize: '0.72rem' }}
                            />
                        ))}
                    </Stack>
                </Box>

                {/* Blocklist Breakdown */}
                {usageCategories.includes("SPORT") && (
                    <Box>
                        <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mb: 0.5 }}>
                            وضعیت محدودیت ورزش:
                        </Typography>
                        {blockedSportIds.length > 0 ? (
                            <Typography variant="caption" sx={{ fontWeight: 700, color: 'error.main' }}>
                                {blockedSportIds.length} رشته ورزشی مسدود شده
                            </Typography>
                        ) : (
                            <Typography variant="caption" sx={{ fontWeight: 700, color: 'success.main' }}>
                                بدون محدودیت ورزشی
                            </Typography>
                        )}
                    </Box>
                )}

                <Divider sx={{ my: 1 }} />

                {estimatedTotal !== null ? (
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <Typography variant="subtitle2" sx={{ fontWeight: 900 }}>برآورد اعتبار کل:</Typography>
                        <Typography variant="h6" sx={{ fontWeight: 900, color: 'success.main' }}>
                            {toPriceWithComma(estimatedTotal)} <span style={{ fontSize: '0.75rem' }}>تومان</span>
                        </Typography>
                    </Box>
                ) : (
                    <Box sx={{ p: 1.5, borderRadius: 2.5, bgcolor: 'action.hover' }}>
                        <Typography variant="caption" color="text.secondary">
                            💡 اعتبار کل به ازای تمام پرسنل فعال سازمان محاسبه خواهد شد.
                        </Typography>
                    </Box>
                )}
            </Stack>
        </Card>
    );
};

export default _CreditBudgetPreview;
